import Money from 'common/components/layout/Money';

const CompareAtPrice = (props) => {
  const { product, settings } = props;
  if (!product.variants) {
    return null;
  }
  const variant = product.variants[0];
  if (!variant) {
    return null;
  }
  const price = variant.comparePrice || variant.price;
  if (!variant.addToCartPrice || variant.addToCartPrice >= price) {
    return (
      <div className="c7-product__variant__price__normal">
        <Money number={price} settings={settings} />
      </div>
    );
  }
  return (
    <div className="c7-product__variant__price__compare">
      <Money number={price} settings={settings} />
    </div>
  );
};

export default CompareAtPrice;
